import { DateSelectCarousel } from '../SearchForm/children/DateSelectCarousel';
import SelectBox from '../SearchForm/children/SelectBox';
import React from 'react';
import styles from './MultiDurationSelectorStyles.module.scss';
export const MultiDurationSelector = ({ dates, setSelectedDurations, selectedDurations = [], name = 'NightSelector', multiselect = false, }) => {
    if (!dates || dates.length === 0) {
        return null;
    }
    const handleDurationChange = (duration) => {
        setSelectedDurations([duration]);
    };
    const handleMultipleDurationChange = (duration) => {
        const newDurations = selectedDurations.includes(duration)
            ? selectedDurations.filter((m) => m !== duration)
            : [...selectedDurations, duration];
        setSelectedDurations(newDurations);
    };
    const handleOnChange = (date) => {
        if (multiselect) {
            return handleMultipleDurationChange(date.value.toString());
        }
        else {
            return handleDurationChange(date.value.toString());
        }
    };
    return (<>
      {dates.length <= 6 ? (<ul className={styles.list} data-testid='multi-duration-selector'>
          {dates === null || dates === void 0 ? void 0 : dates.map((date) => (<li key={date.title} className={styles.item}>
              <SelectBox name={name} onChange={() => handleOnChange(date)} title={date.title} value={date.value} checked={selectedDurations.includes(date.value.toString())} rounded multiSelect={multiselect}/>
            </li>))}
        </ul>) : (<DateSelectCarousel onChange={handleOnChange} preSelectedNights={Number(selectedDurations[0])} dates={dates}/>)}
    </>);
};
